import { gql } from '@apollo/client';


export const ADD_USER_TO_PRODUCT = gql`
    mutation AddUserToProduct($input: AddUserToProductInput) {
        addUserToProduct(input: $input) {
            status
            description
            instanceId
        }
    }
`;


export const CREATE_USER = gql`
mutation createUser($input: UserInput) {
	createUser(input: $input)
}`;

export const IAM_INVITE_USER = gql`
mutation IAMinviteUser($input: InviteUserInput) {
	IAMinviteUser(input: $input){
		message
		status
		user{
			userId
			email
			organizationId
			organizationName
			product
			requestingUserEmail
			role
		}
	}
}`;

export const EDIT_USER = gql`
mutation editUser($input: EditUserInput) {
	editUser(input: $input)
}`;

export const IAM_UPDATE_USER = gql`
mutation IAMupdateUser($input: UpdateUserInput) {
	IAMupdateUser(input: $input){
		message
		status
		user{
			userId
			email
			firstName
			lastName
			organizationId
			mobileNumber
			product
			organizationName
			status
		}
	}
}`;

export const IAM_CHANGE_USER_EMAIL = gql`
mutation IAMchangeEmail($input: ChangeEmailInput) {
	IAMchangeEmail(input: $input){
		message
		status
		user{
			email
			newEmail
		}
	}
}`;

export const IAM_CHANGE_USER_ROLE = gql`
mutation IAMchangeUserRole($input: ChangeUserRoleInput) {
	IAMchangeUserRole(input: $input){
		message
		status
		user{
			userId
			email
			firstName
			lastName
			role
			organizationId
			mobileNumber
			product
			organizationName
			status
		}
	}
}`;

export const IAM_CHANGE_USER_ACCESS_STATUS = gql`
mutation IAMchangeUserAccessStatus($input: ChangeUserAccessStatusInput) {
	IAMchangeUserAccessStatus(input: $input){
		message
		status
		user{
			userId
			email
			firstName
			lastName
			role
			organizationId
			mobileNumber
			product
			organizationName
			status
		}
	}
}`;

export const DELETE_USER = gql`
mutation deleteUser($input: DeleteUserFromAppInput) {
	deleteUser(input: $input)
}`;

export const IAM_DELETE_USER = gql`
mutation IAMdeleteUser($input: DeleteUserInput) {
	IAMdeleteUser(input: $input){
		message
		status
	}
}`;

export const CREATE_TENANT = gql`
mutation createTenant($input: CreateTenantInput) {
	createTenant(input: $input) {
		tenantId
	}
}`;

export const ONBOARD_ORGNIZATION = gql`
mutation IAMonboardOrganization($input: OnboardOrganizationInput) {
	IAMonboardOrganization(input: $input){
		message
		status
		organization{
			product
			organizationId
			organizationName
			organizationStatus
			onboardAdminEmail
			allowedDomains
			restrictedDomains
		}
		admin{
			email
			role
			userId
		}
	}
}`;

export const UPDATE_TENANT = gql`
mutation updateTenant($input: UpdateTenantInput) {
	updateTenant(input: $input)
}`;

export const IAM_CHANGE_ORGNIZATION_NAME = gql`
mutation IAMchangeOrganizationName($input: ChangeOrganizationNameInput) {
	IAMchangeOrganizationName(input: $input){
		message
		status
	}
}`;

export const IAM_CHANGE_ORGNIZATION_STATUS = gql`
mutation IAMchangeOrganizationStatus($input: ChangeOrganizationStatusInput) {
	IAMchangeOrganizationStatus(input: $input){
		message
		status
	}
}`;

export const DELETE_TENANT = gql`
mutation deleteTenant($input: DeleteTenantInput) {
	deleteTenant(input: $input)
}`;

export const IAM_REGISTER_USER = gql`
mutation IAMregisterUser($input: RegisterUserInput) {
	IAMregisterUser(input: $input){
		message
		status
	}
}`;

export const ACCEPT_TERMS_OF_AGREEMENTS = gql`
mutation acceptTermsOfAgreements($input: AcceptTermsOfAgreementsMutation) {
	acceptTermsOfAgreements(input: $input)
}`;

export const CREATE_API_KEY = gql`
mutation createAPIKey($input: createAPIKeyInput) {
	createAPIKey(input:$input){
		apiKey
	}
}`;

export const ADD_DOMAIN_URL = gql`
mutation addDomainURL($input: domainURLInput){
  addDomainURL(input:$input)
}`;

export const DELETE_DOMAIN_URL = gql`
mutation deleteDomainURL($input: domainURLInput){
  deleteDomainURL(input:$input)
}`;

export const CREATE_PROJECT_FILE_MAPPING = gql`
	mutation createProjectFileMapping($input: CreateProjectFileMappingInput) {
		createProjectFileMapping(input: $input)
  	}
`;

export const RUN_FILE_MATCH = gql`
	mutation runFileMatch($input: RunFileMatchInput) {
		runFileMatch(input: $input)
  	}
`;

export const ASSIGN_TENANT_IN_TCR = gql`
mutation assignTenant($input: AssignTenantInput) {
	assignTenant(input: $input)
}`;

export const UPDATE_USER_LOGIN_TIME = gql`
mutation updateUserLoginTime {
	updateUserLoginTime
}`;

export const LOGOUT_USER = gql`
mutation LogoutUser($input: LogoutInput) {
	logoutUser(input: $input)
} 
`;

export const CREATE_USER_REGISTRATION = gql`
  mutation CreateUserRegistrationIntake($input: UserRegistrationInput!) {
    createUserRegistratationIntake(input: $input)
  }
`;

export const SEND_BULK_INVITATIONS = gql`
mutation SendBulkInvitations($input: sendBulkInvitationInput!) {
  sendBulkInvitations(input: $input)
}
`;

export const BENCHMARK_GENERATE_QUARTER_VALUES = gql`
mutation generateQuarterValues($input: GenerateQuarterValuesInput!) {
  DEMOgenerateQuarterValues(input: $input)
}

`;

export const DEMO_GENERATE_QUARTER_VALUES = gql`
mutation generateQuarterValues($input: GenerateQuarterValuesInput!) {
  DEMOgenerateQuarterValues(input: $input)
}

`;

export const BENCHMARK_ANALYZE_ANOMALY_NARRATIVE = gql`
  mutation BENCHMARKanalyzeAnomalyNarrative($input: BenchmarkAnomalyInput!) {
    BENCHMARKanalyzeAnomalyNarrative(input: $input)
  }
`;

export const DEMO_ANALYZE_ANOMALY_NARRATIVE = gql`
  mutation DEMOanalyzeAnomalyNarrative($input: DemoAnomalyInput!) {
    DEMOanalyzeAnomalyNarrative(input: $input)
  }
`;